export const pl = {
  mixed: {
    default: 'Błędna wartość',
    required: 'Wymagane',
    oneOf: 'Błędna wartość',
    notOneOf: 'Niedopuszczalna wartość',
    defined: 'Wymagane',
  },
  string: {
    length: 'Wymagane ${length} znaków',
    min: 'Minimalnie ${min} znaków',
    max: 'Maksymalnie ${max} znaków',
    matches: 'Błędna wartość',
    email: 'Błędny adres',
    url: 'Błędny URL',
    uuid: 'Błędny UUID',
    trim: 'Bez spacji na początku i na końcu',
    lowercase: 'Tylko małe litery',
    uppercase: 'Tylko wielkie litery',
  },
  number: {
    min: 'Większe lub równe ${min}',
    max: 'Mniejsze lub równe ${max}',
    lessThan: 'Mniej niż ${less}',
    moreThan: 'Więcej niż ${more}',
    positive: 'Liczba dodatnia',
    negative: 'Liczba ujemna',
    integer: 'Liczba całkowita',
  },
  date: {
    min: 'Pole ${path} musi zawierać datę późniejszą niż ${min}',
    max: 'Pole ${path} musi zawierać datę wcześniejszą niż ${max}',
  },
  boolean: {
    isValue: 'Pole ${path} musi być ${value}',
  },
  object: {
    noUnknown: 'Nieznane klucze: ${unknown}',
  },
  array: {
    min: 'Minimum ${min} znaków',
    max: 'Maksimum ${max} znaków',
    length: 'Wymagane ${length} znaków',
  }
}